import $ from "jquery"
import modals from "bootstrap/js/dist/modal"
import CryptoJS from "crypto-js";
import Language from '@/assets/js/language/language';
const languageClass = Language.getInstance();

class shareds {
    //物件建立時產生
    constructor(){
    }

    
    /**********
     * 檢查物件是否不存在
     * obj : any object
     */
    isEmpty = (obj) => {
        if(
            typeof obj == 'undefined'
            || obj == null
            || obj.length<=0
        ){
            return true;
        }
        return false;
    }
    //  判斷是否為空物件
    isEmptyObject(obj) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    //顯示全畫面讀取
    LoadingStatus(status,progress=null){
        if (status == 'show'){
            if ( progress != null ){
                
            }
            $('.full-seucce').css('display','flex')
        }else if (status == 'hide'){
            $('.full-seucce').css('display','none')
        }
    }

    //呼叫顯示popup視窗
    initModal(target){
        const modal = new modals(document.getElementById(target));
        return modal
    }
    showModal(modal){
        modal.show();
    }
    //關閉popup視窗
    hideModal(modal){
        modal.hide();
    }


    //換算當地時間
    getLoaclDateTime(dateTime){
        if ( dateTime == null || dateTime == '' || dateTime == -1 || dateTime == '0000-00-00 00:00:00' ){
            return ""
        }
        let timeDate = new Date(dateTime)
        let loaclTime = new Date(timeDate)
        var sy =  loaclTime.getFullYear();   
        var sm = (loaclTime.getMonth()+1).toString().padStart(2,'0');
        var sd = loaclTime.getDate().toString().padStart(2,'0');
        var sh = (loaclTime.getHours()).toString().padStart(2,'0');
        var si = (loaclTime.getMinutes()).toString().padStart(2,'0');
        var ss = loaclTime.getSeconds().toString().padStart(2,'0');

        return sy+"-"+sm+"-"+sd+" "+sh+":"+si+":"+ss;
    }
    //換算當地時間
    getLoaclDate(dateTime){
        if ( dateTime == null || dateTime == '' || dateTime == -1 ){
            return ""
        }
        let timeDate = new Date(dateTime)
        let loaclTime = new Date(timeDate)
        var sy =  loaclTime.getFullYear();   
        var sm = (loaclTime.getMonth()+1).toString().padStart(2,'0');
        var sd = loaclTime.getDate().toString().padStart(2,'0');
        
        return sy+"-"+sm+"-"+sd
    }
    timeElapsedSince(inputTime) {
        // console.log(inputTime);
        const startTime = new Date(inputTime);
        const currentTime = new Date();
        // console.log(startTime);
        // console.log(currentTime);
        const timeDifference = currentTime - startTime;
    
        const hours = Math.floor(timeDifference / 1000 / 60 / 60);
        const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
    
        const formattedTime = `${hours.toString().padStart(2, '0')}h ${minutes.toString().padStart(2, '0')}m ${seconds.toString().padStart(2, '0')}s`;
        return formattedTime;
    }
    //設定往後推延日期
    initEndDate(sDate,maxDay){
        let dateTime = sDate
        let _d = dateTime.setDate(dateTime.getDate()+maxDay)
        return new Date(_d)
    }

    dateFormat(date){
        var _y = date.getFullYear().toString().padStart(4,'0');
        var _m = (date.getMonth()+1).toString().padStart(2,'0');
        var _d = date.getDate().toString().padStart(2,'0');
        // console.log('return=',_y+'-'+_m+'-'+_d)
        return _y+'-'+_m+'-'+_d;
    }

    dateTimeFormat(date){
        var _y = date.getFullYear().toString().padStart(4,'0');
        var _m = (date.getMonth()+1).toString().padStart(2,'0');
        var _d = date.getDate().toString().padStart(2,'0');
        var _H = date.getHours().toString().padStart(2,'0');
        var _i = date.getMinutes().toString().padStart(2,'0');
        var _s = date.getSeconds().toString().padStart(2,'0');
        // console.log('return=',_y+'-'+_m+'-'+_d)
        return _y+'-'+_m+'-'+_d+' '+_H+':'+_i+':'+_s;
    }

    dateTimeRomoveFormat(date){
        var _y = date.getFullYear().toString().padStart(4,'0');
        var _m = (date.getMonth()+1).toString().padStart(2,'0');
        var _d = date.getDate().toString().padStart(2,'0');
        return _y+'-'+_m+'-'+_d
    }

    initEndDate(sDate,maxDay){
        let dateTime = sDate
        let _d = dateTime.setDate(dateTime.getDate()+maxDay)
        return new Date(_d)
    }

    // 使用magicNumber判断圖片類型
    isImage = (buf) => {
        const pngMagic = [0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a];
        const jpeg_jfif = [0x4a, 0x46, 0x49, 0x46];
        const jpeg_exif = [0x45, 0x78, 0x69, 0x66];
        const jpegMagic = [0xFF, 0xD8, 0xFF, 0xE0];
        const gifMagic0 = [0x47, 0x49, 0x46, 0x38, 0x37, 0x61];
        const getGifMagic1 = [0x47, 0x49, 0x46, 0x38, 0x39, 0x61];
        // 6 bytes
        const isGif = data => (arrayEquals(data, gifMagic0) || arrayEquals(data, getGifMagic1))
        // 4 bytes
        const isJpeg = data => (arrayEquals(data, jpegMagic) || arrayEquals(data, jpeg_jfif) || arrayEquals(data, jpeg_exif))
        // 8 bytes
        const isPng = data => arrayEquals(data, pngMagic)
        const arraycopy = (src, index, dist, distIndex, size) => {
            for (let i = 0; i < size; i++) {
                dist[distIndex + i] = src[index + i]
            }
        }
        const arrayEquals = (arr1, arr2) => {
            if (!arr1 || !arr2) {
                return false
            }
            if (arr1 instanceof Array && arr2 instanceof Array) {
                if (arr1.length != arr2.length) {
                    return false
                }
                for (let i = 0; i < arr1.length; i++) {
                    if (arr1[i] != arr2[i]) {
                        return false
                    }
                }
                return true
            }
            return false;
        }
        if (!buf || buf.length < 8) {
            return null;
        }
        let bytes = [];
        arraycopy(buf, 0, bytes, 0, 6);
        if (isGif(bytes)) {
            return "image/gif";
        }
        bytes = [];
        arraycopy(buf, 6, bytes, 0, 4);
        if (isJpeg(bytes)) {
            return "image/jpeg";
        }
        bytes = [];
        arraycopy(buf, 0, bytes, 0, 8);
        if (isPng(bytes)) {
            return "image/png";
        }
        return null;
    }
    checkImage = file => {
        if (!file || !(file instanceof File)) throw '文件不存在'
        return new Promise((resolve, reject) => {
            let reader = new FileReader();
            reader.onload = (evt) => {
                let fileBuf = new Uint8Array(evt.target.result.slice(0, 11));
                let mime = this.isImage(fileBuf);
                resolve(mime)
            };
            reader.onerror = ev => {
                resolve(null)
            }
            reader.readAsArrayBuffer(file);
        })
    }

    // 取得檔案資料
    getImgFileInfo = file => {
        if (!file || !(file instanceof File)) throw '文件不存在'
        return new Promise((resolve, reject) => {
            const url = window.URL || window.webkitURL
            const img = new Image()     
            img.src = url.createObjectURL(file)
            img.onload = () => resolve({ width: img.width, height: img.height })
            img.onload = () => resolve({ success: true, width: img.width, height: img.height })
            img.onerror = () => resolve({ success: false })
        })
    }

    //計算工作天數
    calculateBusinessDate(startDate, days, excludedDates) {
        let businessDate;
        const currentDate = new Date(startDate);
      
        while (days > 0) {
          currentDate.setDate(currentDate.getDate() + 1);
      
          if (
            currentDate.getDay() !== 0 &&
            currentDate.getDay() !== 6 &&
            (
                !excludedDates || 
                !this.isExcludedDate(currentDate, excludedDates)
            )
          ) {
            businessDate = new Date(currentDate);
      
            // 如果时间是下午两点或更晚，天数增加一天
            if (businessDate.getHours() >= 14) {
              days++;
            } else {
              days--;
            }
          }
        }
      
        return this.getFormattedDate(businessDate);
    }
      
    isExcludedDate(date, excludedDates) {
        const formattedDate = this.getFormattedDate(date);
        return excludedDates.some(excludedDate => excludedDate === formattedDate);
    }
      
    getFormattedDate(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
    

    clearLoginStatus(){
        localStorage.removeItem('login_info');
    }

    getUserData(){

        const loginInfo = localStorage.getItem('login_info');
        if (loginInfo) {
            return JSON.parse(loginInfo);
        } 
        return {
            mode:'guest',
            member_id:"",
            area_id:0,
            birthday:"1971-01-01",
            email:"noMail@mail.com",
            name:languageClass.getLanguage('guest'), //
            height:170,
            weight:50,
            sex:1,
            loginTime:this.dateTimeFormat(new Date())
        };
        
    }
    //加密
    newEncrypt(data){
        const hash = CryptoJS.SHA256('ideabus').toString();
        let key = hash.substring(0, 16);
        console.log(`key=${key}`)
        let iv = hash.substring(16, 32);
        console.log(`iv=${iv}`)
        // const padding = 16 - (data.length % 16);
        // data += String.fromCharCode(padding).repeat(padding);
        return CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(data), CryptoJS.enc.Utf8.parse(key), {
          iv: CryptoJS.enc.Utf8.parse(iv),
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        }).ciphertext.toString(CryptoJS.enc.Base64);
    }
    //解密
    newDecrypt(data){
        const hash = CryptoJS.SHA256('ideabus').toString();
        let key = hash.substring(0, 16);
        let iv = hash.substring(16, 32);
        const ciphertext = CryptoJS.enc.Base64.parse(data);
        const decryptedBytes = CryptoJS.AES.decrypt(
          { ciphertext },
          CryptoJS.enc.Utf8.parse(key),
          {
            iv: CryptoJS.enc.Utf8.parse(iv),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
          }
        );
        
        const decryptedText = decryptedBytes.toString(CryptoJS.enc.Utf8);
        return decryptedText;
    }
    encodeToBase64(str) {
        return btoa(str);
    }

    decodeFromBase64(encodedStr) {
        return decodeURIComponent(encodedStr);
    }

    getNowDate(){
        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth() + 1; // 月份是從 0 開始的，所以要加 1
        const date = today.getDate();

        const formattedDate = `${year}-${month.toString().padStart(2, '0')}-${date.toString().padStart(2, '0')}`;
        return formattedDate
    }

    offLineSetRainingRecordsToLocal(latestTrainingRecord) {
        const trainingRecord = JSON.parse(localStorage.getItem('trainingRecord')) || [];
        console.log('trainingRecord', trainingRecord);
        trainingRecord.push(latestTrainingRecord);
        localStorage.setItem('trainingRecord',JSON.stringify(trainingRecord));
        localStorage.setItem('latestTrainingRecord',JSON.stringify({}));
    }

    getWeekNumber(date) {
        date = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
        date.setUTCDate(date.getUTCDate() + 4 - (date.getUTCDay() || 7));
        var yearStart = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));
        var weekNumber = Math.ceil(((date - yearStart) / 86400000 + 1) / 7);
        return weekNumber;
    }
      

    initTrainingTarget(){
        const today = new Date();
        return {
            weekNumber:this.getWeekNumber(today),
            weekForDayCount:[[],[],[],[],[],[],[]]
        }
    }

    setTrainingTarget(latestTrainingRecord){
        let trainingTarget = JSON.parse(localStorage.getItem('trainingTarget')) || this.initTrainingTarget();
        //取得今天日期
        var today = new Date().getDay();
        trainingTarget.weekForDayCount[today].push(latestTrainingRecord.training_time)
        localStorage.setItem('trainingTarget', JSON.stringify(trainingTarget) );
    }

    initSetting(){
        return {weekTarget:7,dayTarget:10}
    }

    //取得歲數
    calculateAge(birthdate) {
        const today = new Date();
        const birthDate = new Date(birthdate);
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();
    
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
    
        return age;
    }
    //取得年齡區間代碼
    getAgeInterval(birthdate){
        let age = this.calculateAge(birthdate)
        if (age >= 100) {
            return 20;
        } else {
            return Math.floor(age / 5);
        }
    }

    initLocalStorageData(){
        let game_record_str = localStorage.getItem('game_record');
        // 檢查是否有資料
        if (!game_record_str) {
        // 如果沒有資料，則初始化一個新的物件
        let game_record = {
            date: this.getNowDate(),
            gamelist: []
        };
        // 將物件轉換為 JSON 字串後存入 localStorage
        localStorage.setItem('game_record', JSON.stringify(game_record));
        } else {
        // 如果有資料，則將 JSON 字串轉換為物件
        let game_record = JSON.parse(game_record_str);
      // 檢查是否存在當日的記錄
      if (game_record.date != this.getNowDate() ){
        game_record = {
          date: this.getNowDate(),
          gamelist: []
        }
        localStorage.setItem('game_record', JSON.stringify(game_record));
      }
    }

    let trainingTarget = localStorage.getItem('trainingTarget')
    if ( !trainingTarget ){
      localStorage.setItem('trainingTarget', JSON.stringify(this.initTrainingTarget()) );
    }else{
      //判斷是否為同一週
      trainingTarget = JSON.parse(trainingTarget)
      if ( trainingTarget.weekNumber != this.getWeekNumber(new Date()) ){
        localStorage.setItem('trainingTarget', JSON.stringify(this.initTrainingTarget()) );
      }
    }
    if ( !localStorage.getItem('trainingRecord') ){
      localStorage.setItem('trainingRecord', JSON.stringify([]) );
    }

    if ( !localStorage.getItem('setting') ){
      localStorage.setItem('setting', JSON.stringify(this.initSetting()) );
    }
    }


}
export default shareds